/**
 * BaseModal - Main entry point
 * Modular modal library with advanced features
 */

import StaticMethods from './static-methods.js';

// Create BaseModal object with all static methods
const BaseModal = {
    init         :StaticMethods.init,
    show         :StaticMethods.show,
    close        :StaticMethods.close,
    destroy      :StaticMethods.destroy,
    confirm      :StaticMethods.confirm,
    isOpen       :StaticMethods.isOpen,
    getOpenModals:StaticMethods.getOpenModals,
    closeAll     :StaticMethods.closeAll,
    closeTopmost :StaticMethods.closeTopmost,
    getInstance  :StaticMethods.getInstance,
    setDefaults  :StaticMethods.setDefaults,
    destroyAll   :StaticMethods.destroyAll,
    setTheme     :StaticMethods.setTheme,
    use          :StaticMethods.use,
    getPlugin    :StaticMethods.getPlugin,
    getPlugins   :StaticMethods.getPlugins
};

// Export as default
export default BaseModal;

// Expose to window for global access
if (typeof window !== 'undefined') {
    window.BaseModal = BaseModal;
}
